import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import SlideView from "@/views/share/SlideView.vue";
import {h, reactive} from "vue";
import {MenuProps} from "ant-design-vue";
import {useRoute} from "vue-router";
import {UserAgent} from "@/model/user_agent";
import {InfoCircleOutlined, UserOutlined} from "@ant-design/icons-vue";
import router from "@/views";
import {IBranch, IBrand} from "@/model/brand_manager";


export default /*@__PURE__*/_defineComponent({
  __name: 'BranchSideView',
  setup(__props) {


const route = useRoute();
const meta = {
  agent: route.meta.agent as UserAgent,
  brand: route.meta.brand as IBrand,
  branch: route.meta.branch as IBranch
};

const info = reactive({
  menu: {
    toggle: false,
    items: [
      {key: meta.branch.branch_id, icon: h(UserOutlined), label: '概况'},
      {key: 'customers', icon: h(UserOutlined), label: '新老客'},
      {key: 'signs', icon: h(UserOutlined), label: '报名顾客'},
      {key: 'distributors', icon: h(UserOutlined), label: '分销员'},
      {key: 'views', icon: h(UserOutlined), label: '访客记录'},
      {key: 'employees', icon: h(UserOutlined), label: '内部成员'},
      {key: 'orders', icon: h(UserOutlined), label: '订单管理'},
      {key: 'info', icon: h(InfoCircleOutlined), label: '门店信息'},
    ] as MenuProps['items'],
    openKeys: [] as string[],
    selectedKeys: [route.path.split('/').last()] as string[],
  }
});


const onMenuClick = (e: any) => {
  if (e.key === meta.branch.branch_id) router.push(`/brand/${meta.branch.brand_id}/branch/${meta.branch.branch_id}`);
  else router.push(`/brand/${meta.branch.brand_id}/branch/${meta.branch.branch_id}/${e.key}`);
}


return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createBlock(SlideView, {
    toggle: info.menu.toggle,
    "onUpdate:toggle": _cache[2] || (_cache[2] = ($event: any) => ((info.menu.toggle) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_flex, {
        gap: "small",
        style: {"padding":"18px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_avatar, {
            size: "large",
            src: meta.brand.icon ? meta.brand.icon+'-sq.60' : ''
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(meta.brand.name[0]), 1)
            ]),
            _: 1
          }, 8, ["src"]),
          (!info.menu.toggle)
            ? (_openBlock(), _createBlock(_component_a_flex, {
                key: 0,
                vertical: "",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_typography_text, {
                    ellipsis: "",
                    content: meta.brand.name
                  }, null, 8, ["content"]),
                  _createVNode(_component_a_typography_text, { type: "secondary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(meta.branch.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_a_menu, {
        items: info.menu.items,
        "inline-collapsed": info.menu.toggle,
        "open-keys": info.menu.openKeys,
        "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((info.menu.openKeys) = $event)),
        "selected-keys": info.menu.selectedKeys,
        "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((info.menu.selectedKeys) = $event)),
        mode: "inline",
        onClick: onMenuClick
      }, null, 8, ["items", "inline-collapsed", "open-keys", "selected-keys"])
    ]),
    _: 1
  }, 8, ["toggle"]))
}
}

})